import { Component, OnInit, Input } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-prompt-dialog",
  templateUrl: "./prompt-dialog.component.html",
  styleUrls: ["./prompt-dialog.component.css"],
})
export class PromptDialogComponent implements OnInit {
  inputForm: FormGroup;

  @Input() title: string;
  @Input() message: string;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;
  email: any;
  constructor(private activeModal: NgbActiveModal) {}

  ngOnInit() {
    this.email = this.message;

    this.inputForm = new FormGroup({
      email: new FormControl(""),
    });
  }

  public decline() {
    this.activeModal.close();
  }

  public accept() {
    this.email = this.inputForm.value.email;
    console.log(this.email);
    this.activeModal.close(this.email);
  }

  public dismiss() {
    this.activeModal.dismiss();
  }
}
